module.exports = new __parcel__URL__("C4O1.d398bd73.png").toString();